export default {"src":"/_next/static/media/edit-file.f4e711d9.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};